import { SetUpTenantInfoSendWithHttpRequests } from './tenant-axios-interceptor';
import { getTenant } from './get-tenant';
import { Tenant } from './tenant';

export function initializeTenantSupport(): Tenant {
  SetUpTenantInfoSendWithHttpRequests();
  return getTenant();
}
